import { useUser } from "hooks/user"

import Marketplace from "./components/Marketplace"
import Whatsapp from "./components/Whatsapp"
import Referrer from "./components/Referrer"
import Email from "./components/Email"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { AnimatePresence, motion } from "framer-motion"
import AuthLayout from "layouts/AuthLayout"

// Steps after email verification share one AuthLayout, so moving between them
// only animates the step content instead of remounting the whole page.
const steps: Record<string, { title: string; page: string; pageWidth: string; content: JSX.Element }> = {
    whatsapp: { title: "Verify WhatsApp - Sellerdash", page: "WhatsApp Verify", pageWidth: "40%", content: <Whatsapp /> },
    marketplace: { title: "Marketplace - Sellerdash", page: "Marketplace", pageWidth: "30%", content: <Marketplace /> },
    referrer: { title: "Referrer - Sellerdash", page: "Referrer", pageWidth: "30%", content: <Referrer /> },
}

const Onboarding = () => {
    const { user } = useUser()
    const navigate = useNavigate()
    useEffect(() => {
        if(!user)
            navigate("signin")
    }, [user])

    const stepKey = user?.onboarding || "whatsapp"
    // Email verification renders its own layout (the Verify page is shared).
    if (stepKey === "email") return <div className="w-full h-screen overflow-hidden"><Email /></div>

    const step = steps[stepKey]
    if (!step) return null

    return (
        <div className="w-full h-screen overflow-hidden">
            <AuthLayout title={step.title} page={step.page} pageWidth={step.pageWidth}>
                <AnimatePresence mode="wait" initial={false}>
                    <motion.div
                        key={stepKey}
                        initial={{ opacity: 0, x: 24 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -24 }}
                        transition={{ duration: 0.25, ease: "easeOut" }}
                    >
                        {step.content}
                    </motion.div>
                </AnimatePresence>
            </AuthLayout>
        </div>
    )
}

export default Onboarding
